import React from 'react';
import CentrosProfile from '../containers/CentrosProfile'

import '../../styles/custom.css'
import '../../styles/iconos.css'

export default ({ result }) => {
    const universityCases = {
        'UDD': 'Universidad del Desarrollo',
        'UNAB': 'Universidad Andrés Bello',
        'PUC': 'Pontificia Universidad Católica de Chile',
        'UAndes': 'Universidad de los Andes',
        'UFRO': 'Universidad de La Frontera'
    }
    return (
        <li className="sui-result contenedor-investigador" 
            style={{
                margin: '10px auto',
                textAlign: 'center'
            }}>
                <div className="sui-result__header cabezera-investigador"  
                style={{
                    justifyContent: 'center',
                    height: 65,
                }}>
                    <span className="texto-cabezera-centro"
                        dangerouslySetInnerHTML={{__html: 
                            result.acronimo.raw?
                                ((result.nombre_centro?.snippet).toString()+' ('+result.acronimo.snippet+')'):
                                (result.nombre_centro?.snippet).toString()
                        }}
                        
                        >

                        
                    </span>
                    
                </div>
                <div className="sui-result__body">
                    <ul className="sui-result__details" 
                        style={{
                            margin: '0px 5%',
                            textAlign: 'left'
                            }}>
                            {    /*
                        <li>
                            <span className="sui-result__key">Centro:</span>
                            <span className="sui-result__value"
                            dangerouslySetInnerHTML={{__html: result.id_centro?.raw}}
                            ></span>
                        </li>
                    */}
                        <li>
                            <span className="sui-result__key">Descripción:</span>
                            <span className="sui-result__value recortar-texto-max-5"
                            dangerouslySetInnerHTML={{__html: result.descripcion?.raw}}
                            ></span>
                        </li>

                        <li>
                            <span className="sui-result__key">Universidad:</span>
                            <span className="sui-result__value recortar-texto-max-5">{ universityCases[result.universidad?.raw] || result.universidad?.raw }</span>
                        </li>

                        <li>
                            <span className="sui-result__key">Facultad:</span>
                            <div>
                                <a className="sui-result__value_centro sui-result__value" href={result.link_facultad?.raw || null} rel="noopener noreferrer" target="_blank">{result.facultad?.raw}</a>
                            </div>
                        </li>
                    
                    </ul>
                </div>
                <div className="sui-result__footer">
                    <CentrosProfile data={result}/>
                </div>

        </li> 
    )
}